// @flow
import update from 'immutability-helper';
import { ofType } from 'redux-observable';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { setNewAlert } from '../../../alert/duck';
import { endpoints, postSetTrackingNumberApi } from './api';

import type { Order } from '../../../../entities';
import type { HTTPError } from '../../../../error';
import type { Observable } from 'rxjs';
import type { PurchasedAction } from '../../Sale/purchased/duck';

export type CourierFlowAction = {
  +type: string;
  +order?: Order;
  +orderId?: string;
  +itemNumber?: number;
  +trackingCourier?: string;
  +trackingNumber?: string;
  +trackingUrl?: string;
  +error?: HTTPError;
};

export type CourierFlowState = {
  itemTrackingNumberLoadingMap: {
    [key: string]: boolean;
  };
  itemTrackingNumberErrorMap: {
    [key: string]: HTTPError;
  };
};

const COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST = 'COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST';
const COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS = 'COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS';
const COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR = 'COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR';

const RESET_STATE = 'RESET_STATE';

// Action Creators
export function setTrackingNumber(
  orderId: string,
  itemNumber: number,
  trackingCourier: string,
  trackingNumber: string,
  trackingUrl?: string,
): CourierFlowAction {
  return {
    type: COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST,
    orderId,
    itemNumber,
    trackingCourier,
    trackingNumber,
    trackingUrl,
  };
}

export function setTrackingNumberSuccess(itemNumber: number, order: Order): CourierFlowAction {
  return {
    type: COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS,
    itemNumber,
    order,
  };
}

export function setTrackingNumberError(error: HTTPError, itemNumber: number): CourierFlowAction {
  return {
    type: COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR,
    error,
    itemNumber,
  };
}

export function resetState(): CourierFlowAction {
  return {
    type: RESET_STATE,
  };
}

export const actions = {
  COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST,
  COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS,
  COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR,
  RESET_STATE,
  setTrackingNumber,
  setTrackingNumberSuccess,
  setTrackingNumberError,
  resetState,
};

export const initialState: CourierFlowState = {
  itemTrackingNumberLoadingMap: {},
  itemTrackingNumberErrorMap: {},
};

export default function reducer(state: CourierFlowState = initialState,
                                action: CourierFlowAction): CourierFlowState {
  switch (action.type) {
    case COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST:
      if (typeof action.itemNumber !== 'number') {
        return state;
      }
      return update(state, {
        itemTrackingNumberLoadingMap: {
          [`${action.itemNumber}`]: { $set: true },
        },
        itemTrackingNumberErrorMap: {
          $unset: [`${action.itemNumber}`],
        },
      });
    case COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS:
      if (typeof action.itemNumber !== 'number') {
        return state;
      }
      return update(state, {
        itemTrackingNumberLoadingMap: {
          [`${action.itemNumber}`]: { $set: false },
        },
        itemTrackingNumberErrorMap: {
          $unset: [`${action.itemNumber}`],
        },
      });
    case COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR:
      if (typeof action.itemNumber !== 'number') {
        return state;
      }
      return update(state, {
        itemTrackingNumberLoadingMap: {
          [`${action.itemNumber}`]: { $set: false },
        },
        itemTrackingNumberErrorMap: {
          [`${action.itemNumber}`]: { $set: action.error },
        },
      });
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function setCourierFlowTrackingNumberEpic(action$: Observable<PurchasedAction>): Observable<PurchasedAction> {
  return action$.pipe(
    ofType(COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST),
    mergeMap(({ orderId, itemNumber, trackingCourier, trackingNumber, trackingUrl }) =>
      postSetTrackingNumberApi({ trackingCourier, trackingNumber, trackingUrl }, {
        route: endpoints.SET_TRACKING_NUMBER
          .replace(':orderId', orderId)
          .replace(':itemNumber', itemNumber),
      }).pipe(
        map((order: Order) => setTrackingNumberSuccess(itemNumber, order)),
        catchError((e: HTTPError) => of(setTrackingNumberError(e, itemNumber)))),
    ));
}



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/courier-flow/duck.js